import React from "react";
import ConnectVector from "../assets/Connect-Vector.png";
import Button from "../assets/Boton-Connect-2.png";
import { useStateContext } from "../utils/web3";

function ConnectWallet() {
  const { connectWallet } = useStateContext();
  return (
    <div className="flex ow-90 oh-90 m-auto relative">
      <div className="relative flex flex-row items-center justify-between overflow-hidden nonconformistducks-bg h-full w-full rounded-3xl">
        <div className="flex flex-col items-center h-full w-full justify-center">
          <button onClick={connectWallet} className="h-1/4 md:h-2/6 mb-3">
            <img src={Button} alt="Nonco Ducks Logo"
              className="h-full"/>
          </button>
          <img src={ConnectVector} alt="Nonco Ducks Logo"
            className="h-1/6 md:h-1/5"/>
        </div>
      </div>
    </div>
  );
}

export default ConnectWallet;
